<style>
    .content {
      display: flex;
      margin: 82px auto 32px;
      padding: 0 16px;
      max-width: 960px;
      flex-direction: column;
      align-items: center;
      height: calc(100vh - 230px);
    }
  
    .card-modulo { transition: all .2s ease-in-out; }
    .card-modulo:hover { transform: scale(1.05); cursor: pointer; box-shadow: 0 0 11px rgba(33,33,33,.2); }
</style>
<div class="content" role="main">
    <!-- Highlight Card -->
    <button pButton type="button" label="Bem vindo ao ISSQN" ></button>

    <div style="margin-top: 50px; display: flex; flex-direction: column;width: 100%;text-align: center;">
        <!-- Resources -->
        <h2>Selecione abaixo o módulo que deseja acessar:</h2>
    
        <div class="card-container" style="padding-top: 30px;display: flex;justify-content: space-evenly;">
            <p-card header="Notas Fiscais" [style]="{width: '215px',height: '260px'}" styleClass="p-card-shadow" class="card-modulo"
                (click)="navegarNotaFiscal()">
                <ul style="list-style: none;padding: 0px;">
                    <li style="border-bottom: 1px solid #eee;text-align: center;padding: 1rem;font-size: small;">Importar notas fiscais</li>
                    <li style="border-bottom: 1px solid #eee;text-align: center;padding: 1rem;font-size: small;">Verificar status da importação</li>
                    <li style="border-bottom: 1px solid #eee;text-align: center;padding: 1rem;font-size: small;">Relatórios</li>
                </ul>
            </p-card>
        </div>
    </div>
</div>